import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusPandemicBlog: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: From Pandemic to Progress: Pearl Agarwal’s Journey in
          Building Eximius Ventures
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Pearl Agarwal, Founder & Managing Partner,
          <Link href="https://eximiusvc.com/" target="_blank" rel="noreferrer">
            Eximius Ventures
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member VC
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. In this exclusive chat with Pearl Agarwal,
          speak In this exclusive Q&A, Pearl Agarwal, Founder and Managing
          Director of Eximius Ventures, shares insights into the firm’s journey
          since its inception in 2020. Discover how Eximius is bridging the
          funding gap for pre-seed startups, fostering visionary founders, and
          shaping India’s evolving startup ecosystem with a bold, thesis-driven
          approach.
        </Text>
      </Box>

      <Img
        src="https://static.levocdn.com/WGLBUT82/pixelcut-export-hjBOvG4oRlDv.png"
        alt="Perl"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Pearl Agarwal, Founder & Managing Partner,{' '}
            <Link
              href="https://eximiusvc.com/"
              target="_blank"
              rel="noreferrer"
            >
              Eximius Ventures
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="start" mt="5px">
              <Link
                href="https://in.linkedin.com/in/pearl-agarwal"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. Founding a VC firm in 2020 came with unique challenges given the
            pandemic. What motivated you to start Eximius at that time, and how
            has the firm evolved since?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Founding a VC firm in 2020 presented unique challenges, especially
            given the disruptions caused by the COVID-19 pandemic. Economies
            were reeling, and the startup ecosystem faced significant
            uncertainty. Many early-stage founders struggled to secure funding
            as larger funds shifted focus to later-stage investments to mitigate
            risk. At the same time, the entrepreneurial spirit in India
            flourished, with innovative ideas emerging from the unique
            challenges of the pandemic. This environment, coupled with personal
            experiences and a belief that crises often give rise to
            opportunities, motivated the launch of Eximius Ventures in March
            2021. <br /> <br />
            Eximius was founded to bridge the funding gap at the pre-seed stage
            and support visionary founders during uncertain times. Since its
            inception, the firm has become a trusted partner for pre-seed
            entrepreneurs, investing in 24 companies across the Fintech, SaaS,
            Healthtech, and ConsumerTech sectors. Around 50% of these portfolio
            companies have successfully raised follow-on funding, highlighting
            their growth and the value Eximius brings as a first institutional
            investor.
          </Text>
        </Box>

        {/* Question 5 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. For aspiring founders, access to capital is often a major hurdle.
            How is Eximius addressing this challenge specifically within the
            Indian market?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Access to early-stage capital is a well-known challenge for Indian
              entrepreneurs. Many founders, especially at the pre-seed stage,
              find it difficult to secure the first institutional cheque due to
              limited access to established networks and a lack of investor
              confidence in nascent ideas - Eximius was established to address
              this gap. <br /> <br />
              We focus on providing the first institutional cheque to founders
              who have a strong vision but need initial capital to build their
              product, iterate on their business model, and achieve early
              traction. What sets Eximius apart is our deep thesis-driven
              approach, which allows us to identify promising startups early and
              invest confidently. Beyond capital, we offer hands-on support,
              from strategic advice to operational guidance, and connect
              founders with a robust network of industry leaders and potential
              partners. Additionally, we have funds reserved for follow-on
              rounds, ensuring that our portfolio companies have the financial
              backing they need as they scale, alongside connecting them with
              marquee investors.
            </Text>
          </Box>
        </Box>
        {/*  */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            3. Eximius Ventures is positioned as a pre-seed stage fund for
            visionary founders. How would you define a "visionary founder," and
            what qualities do you specifically look for during initial meetings
            with founders?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              A visionary founder isn’t just someone with a groundbreaking
              idea—they’re someone who can see the future of their industry and
              take actionable steps to get there. At Eximius, we’re drawn to
              founders who combine bold vision with the grit and determination
              to bring it to life. Vision alone won’t cut it. Founders need to
              show they can navigate challenges, adapt quickly to changing
              market dynamics, and learn from missteps along the way. <br />{' '}
              <br />
              When we sit down with founders, we’re looking for those with deep
              domain expertise, who live and breathe the problem they’re
              solving. They understand their target market, the competitive
              landscape, and what it takes to stand out. Beyond this, we value
              founders who are natural problem-solvers—innovative thinkers who
              aren’t afraid to iterate and refine their product until they nail
              the solution. <br /> <br />
              In addition to that, Leadership is key. The best founders attract
              top talent and build a culture that inspires teams to push
              boundaries. We also look for unwavering passion and drive—those
              who are relentless in their mission to create something truly
              transformative. <br /> <br />
              At Eximius, we pride ourselves on being the first believers in
              these visionary founders. We’re not just early capital; we’re a
              partner on their journey, offering insights, connections, and
              unwavering support from day one. We’re here to back the bold, and
              together, we help turn ambitious ideas into global businesses.
            </Text>
          </Box>
        </Box>

        {/* Question 7 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            4. With plans to invest in 10–12 startups in FY 2024–2025, what are
            the key growth metrics or milestones you’ll be focusing on in your
            portfolio companies?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              At Eximius, we focus on identifying key indicators of success at
              the pre-seed stage, where the emphasis lies in evaluating a
              founder&apos;s pedigree, deep market understanding, and the
              market&apos;s capacity to accommodate their product. We seek
              founders who possess not only an intimate knowledge of their
              market but also a clear vision to address its unmet needs. <br />{' '}
              <br />
              At this stage, early traction is a critical factor. We prioritise
              metrics such as strong user growth and organic user acquisition,
              which are clear signals of an initial product-market fit. From
              there, our focus shifts to validating the business model’s ability
              to drive sustained revenue growth from the same set of users,
              ensuring long-term scalability.
            </Text>
          </Box>
        </Box>

        {/* Question 8 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            5. Could you provide some insight into your portfolio management
            strategy? How does Eximius balance between providing guidance and
            allowing founders the autonomy to grow?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              At Eximius, our portfolio management strategy is rooted in
              collaboration. We see ourselves as partners in the founder’s
              journey rather than traditional investors. Our approach strikes a
              careful balance between offering value-added support and ensuring
              that founders retain full autonomy to steer their companies.{' '}
              <br /> <br />
              We believe in providing strategic guidance on key aspects like
              fundraising, hiring, and go-to-market strategies. This involves
              more than just advice—it’s about leveraging our extensive network
              to connect founders with potential customers, industry experts,
              and partners who can accelerate their growth. Through our
              experience-driven founder playbook, we offer actionable frameworks
              to help navigate the common challenges that startups face, whether
              it’s refining their product, scaling operations, or breaking into
              new markets. <br /> <br />
              Communication is another cornerstone of our strategy. We maintain
              regular check-ins to stay aligned with the company’s progress
              while keeping the process non-intrusive. These conversations are
              designed to be supportive, offering feedback and insights when
              needed, but always respecting the founder’s vision and
              decision-making authority. <br /> <br />
              At the heart of our approach is empowerment. We believe founders
              are best positioned to make the critical decisions that shape
              their business. Our role is to be a trusted sounding board,
              providing them with the tools, insights, and confidence to lead
              effectively. By combining this strategic support with the freedom
              to execute their vision, we aim to foster a partnership where
              founders feel both supported and empowered to grow their companies
              on their terms. This collaborative, hands-on yet founder-first
              ethos is what defines Eximius’ commitment to building industry
              leaders from the ground up.
            </Text>
          </Box>
        </Box>

        {/* Question 9 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            6. With a second fund launch on the horizon, what unique
            opportunities or market shifts have you identified that this new
            fund will address?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Fund II is designed to capitalise on the dynamic opportunities
              emerging in India’s rapidly evolving startup ecosystem. The
              acceleration of digital transformation, fuelled by widespread
              smartphone adoption and increasing internet connectivity, has
              created fertile ground for innovation. Sectors such as Fintech,
              AI/SaaS, ConsumerTech and E-Commerce are thriving, each
              experiencing rapid growth as they respond to the evolving needs of
              a digital-first economy. <br /> <br />
              We’re also witnessing an exciting shift in the globalisation of
              Indian startups. More companies are building products designed for
              international markets, tapping into global opportunities while
              leveraging India’s competitive advantages in talent and cost
              efficiency. This trend has sparked a growing demand for
              early-stage capital to support startups as they scale beyond
              borders. <br /> <br />
              Fund II positions Eximius to play a pivotal role in this
              evolution. Our thesis-driven approach allows us to identify and
              back high-potential startups early, providing not only initial
              capital but also the resources and guidance necessary to navigate
              their growth journeys. We are focused on leading pre-seed rounds,
              addressing a clear gap in the ecosystem for a dedicated platform
              approach at this stage. With a significant portion of the fund
              reserved for follow-on investments, we’re committed to supporting
              our portfolio companies as they expand, ensuring they have the
              financial and strategic backing to become leaders in their
              respective industries. This fund represents our continued belief
              in India’s ability to build globally competitive companies and our
              mission to be the first believers in visionary founders shaping
              the future.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            7. Eximius targets key sectors like Fintech, SaaS, Online Media,
            Gaming and Healthtech. Could you share what makes these sectors
            particularly attractive for early-stage investments?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Each of these sectors presents distinctive growth opportunities
              that align perfectly with our investment thesis. India is
              undergoing transformative macro trends, including a migration of
              age with 50% of the population entering the working-age group,
              rapid urbanisation bringing over 100 million people to cities, and
              the rise of a middle-income class with higher disposable incomes.
              Each trend presents distinctive growth opportunities that align
              perfectly with our investment thesis. <br /> <br />
              Fintech, for instance, continues to thrive in India, driven by
              groundbreaking innovations in digital payments, lending platforms,
              and broader financial inclusion initiatives. The sector benefits
              from a supportive regulatory environment, the untapped potential
              of the India Stack with 900 million users yet to be captured, and
              the growth of FinSaaS models, making it a particularly promising
              space for early-stage investments. <br /> <br />
              SaaS is another area where India is making its mark globally.
              Indian SaaS companies are leveraging the country’s exceptional
              tech talent and cost efficiencies to build scalable solutions with
              recurring revenue models. These businesses are solving domestic
              problems and increasingly catering to global markets, which have
              seen a notable increase in the adoption of Indian SaaS solutions
              in 2023, creating significant opportunities for growth and value
              creation. <br /> <br />
              In the realm of online media and gaming, the rise in content
              consumption and the popularity of gaming, particularly among
              younger demographics, offer immense potential for monetisation and
              community building. This sector’s ability to foster highly engaged
              user bases makes it an attractive investment category, with
              opportunities spanning across new content formats and innovative
              engagement models. <br /> <br />
              Healthtech, meanwhile, has experienced a massive surge in adoption
              following the pandemic. Startups in this space are tackling
              critical gaps in healthcare delivery, diagnostics, and preventive
              care, offering innovative digital health solutions that enhance
              accessibility and efficiency. This sector remains ripe for
              disruption, with companies poised to redefine how healthcare is
              delivered and experienced. <br /> <br />
              These focus areas not only align with our mission to back
              transformative businesses but also reflect the broader trends
              shaping India’s startup ecosystem. In addition to these sectors,
              Eximius is keen to explore opportunities in FrontierTech while
              remaining committed to investing in pre-seed startups.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            8. India’s startup ecosystem is evolving rapidly. How do you view
            Eximius role in supporting this growth, especially for pre-seed
            ventures?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Eximius plays a vital role in nurturing India’s startup ecosystem
              by focusing on the often-overlooked pre-seed stage. As one of the
              few institutional investors at this level, and the only dedicated
              pre-seed fund, we are committed to supporting visionary founders
              from the very beginning. Our mission is to provide not only the
              capital but also the guidance and resources needed to transform
              early ideas into scalable businesses. By addressing the funding
              gap at this crucial stage, we provide a platform to de-risk
              pre-seed investments, help startups achieve follow-on funding, and
              raise seed rounds with a sustainable model. This approach ensures
              startups validate their concepts, achieve product-market fit, and
              position themselves for future growth. <br /> <br />
              What sets us apart is our deep sector-specific expertise and
              extensive network, which give founders a distinct edge in
              navigating challenges and capitalising on market opportunities. We
              pride ourselves on being more than just investors—we’re long-term
              partners dedicated to every step of their journey. Our goal is to
              contribute meaningfully to the growth and maturity of India’s
              entrepreneurial ecosystem, enabling founders to build businesses
              that leave a lasting impact.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            9. What advice would you give aspiring Indian founders who may not
            yet feel ready to pursue funding? How can they prepare for an
            early-stage VC partnership with Eximius or similar firms?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              For aspiring founders, thorough preparation is essential before
              approaching early-stage VCs. One of the first steps is refining
              the business model. One needs to clearly articulate your value
              proposition and ensure that your business model is both viable and
              scalable. Investors want to see that you have a solid foundation
              for growth. Equally important is building a strong team. VCs place
              a high value on a founding team with complementary skills and a
              shared vision, as it significantly enhances a startup&apos;s
              chances of success. <br /> <br />
              Demonstrating early traction can also make a compelling case. Even
              at the pre-seed stage, showcasing tangible progress such as pilot
              programs, early customer feedback, or a working prototype provides
              evidence that your idea has real potential. Understanding your
              market is critical too. Founders must have a comprehensive grasp
              of their target market, competitive landscape, and the specific
              problem they’re solving. Lastly, being coachable is a trait that
              VCs highly appreciate. Founders who are open to feedback and
              willing to iterate on their ideas are more likely to succeed in
              the dynamic startup environment. <br /> <br />
              At Eximius, we go beyond providing capital to help founders
              succeed. We follow a 3C approach—Content, Capital, and
              Community—designed to meet the unique needs of pre-seed stage
              founders. Through our bi-weekly newsletters and funding updates,
              we offer insights into market trends and the VC perspective. We’ve
              also rolled out a comprehensive pre-seed guide to equip founders
              with the strategies they need to navigate their early stages. In
              addition, our deep thesis pieces on sectors like fintech and
              gaming, with more in the pipeline, provide targeted knowledge to
              help founders stay ahead of the curve. This 3C approach ensures
              that our founders not only secure funding but also gain access to
              a thriving community and valuable resources that support their
              growth journey.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            10. Lastly, what is your long-term vision for Eximius Ventures?
            Where do you see the firm’s impact in five to ten years in
            India&apos;s startup ecosystem?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Our long-term vision for Eximius Ventures is to be a driving force
              in shaping India’s entrepreneurial landscape, setting the standard
              for what a pre-seed investor can achieve. In the next five to ten
              years, we aim to be recognised not just for our investments but
              for the enduring ecosystem we help build—one where founders can
              access the right capital, insights, and networks to create
              transformative businesses with global impact. <br /> <br />
              We see ourselves as more than a venture capital firm. Eximius is
              committed to becoming a hub for innovation, where founders not
              only secure early funding but gain access to a thriving community
              of peers, mentors, and industry leaders. By continually refining
              our 3C approach; Content, Community, and Cheque Zero - we are
              evolving alongside the needs of the ecosystem, ensuring that we
              provide early-stage support and that our portfolio companies are
              equipped to navigate new challenges and opportunities. <br />{' '}
              <br />
              Our focus extends to shaping industries, driving systemic change,
              and contributing to India’s rise as a global innovation
              powerhouse. We envision a future where Eximius-backed companies
              lead in their sectors, create significant employment, and
              influence markets worldwide, reflecting our belief in the
              potential of Indian startups to drive meaningful and lasting
              change on a global scale.
            </Text>
          </Box>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusPandemicBlog;
